<template lang="html">
  <div class="col-lg-9 col-page-content page-cv">
    <div class="row">

      <div class="col-12">
        <div class="box-bubble">
          <div class="row">

            <div class="col-12 box-acc-title-s1">
              <h4>Mi Curriculum</h4>
              <hr />
            </div>

            <!-- CV -->
            <section class="cv-section">
              <div class="col-12 box-sec-title">
                <div class="col col-icon">
                  <img src="public/images/pages/account/cv-icon-info.png">
                </div>
                <div class="col col-title">
                  <h5 class="title">Información general</h5>
                  <div class="box-btn">
                    <a class="btn btn-cur-1 btn-edit" @click="selectedModalCV = 'cv1-informacion'">Editar</a>
                  </div>
                  <hr class="sep" />
                </div>
              </div>

              <div class="col-12 box-gral-info">
                <div class="row">
                  <div class="col col-info">
                    <div v-html="$root.user.usercompany.cv">
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <!--  -->

            <!-- Educación -->
            <section class="cv-section">
              <div class="col-12 box-sec-title">
                <div class="col col-icon">
                  <img src="public/images/pages/account/cv-icon-education.png">
                </div>
                <div class="col col-title">
                  <h5 class="title">Educación</h5>
                  <div class="box-btn">
                    <a class="btn btn-cur-1 btn-edit" @click="selectedModalCV = 'cv2-education'">Agregar</a>
                  </div>
                  <hr class="sep" />
                </div>
              </div>

              <div class="col-12 box-table-info" v-for="(education, eduInx) in $root.user.cv.educations" :key="'eduInx-'+eduInx">
                <div class="row">
                  <div class="col col-years">
                    <h6>{{education.desde}} - {{education.hasta}}</h6>
                  </div>

                  <div class="col col-info">
                    <ul>
                      <li>{{education.institucion}}</li>
                    </ul>

                    <h5 class="title">{{education.formacion}}</h5>
                    <p class="descr">{{education.descripcion}} </p>
                  </div>

                  <div class="col col-buttons">
                    <a class="btn-circle trans-150 btn-edit" @click="editEduc(eduInx)"><i class="fas fa-pencil-alt"></i></a>
                    <a class="btn-circle trans-150 btn-delete" @click="deleteEduc(education.id)"><i class="fas fa-trash-alt"></i></a>
                  </div>
                </div>
              </div>
            </section>
            <!--  -->

            <!-- Experiencia Laboral -->
            <section class="cv-section">
              <div class="col-12 box-sec-title">
                <div class="col col-icon">
                  <img src="public/images/pages/account/cv-icon-experience.png">
                </div>
                <div class="col col-title">
                  <h5 class="title">Experiencia Laboral</h5>
                  <div class="box-btn">
                    <a class="btn btn-cur-1 btn-edit" @click="selectedModalCV = 'cv3-experience'">Agregar</a>
                  </div>
                  <hr class="sep" />
                </div>
              </div>

              <div class="col-12 box-table-info" v-for="(exp, expInx) in $root.user.cv.experiences" :key="'expInx-'+expInx">
                <div class="row">
                  <div class="col col-years">
                    <h6>{{exp.desde}} - {{exp.hasta}}</h6>
                  </div>

                  <div class="col col-info">
                    <ul>
                      <li>{{exp.empresa}}</li>
                    </ul>

                    <h5 class="title">{{exp.puesto}}</h5>
                    <p class="descr">{{exp.descripcion}}</p>
                  </div>

                  <div class="col col-buttons">
                    <a class="btn-circle trans-150 btn-edit" @click="editExp(expInx)"><i class="fas fa-pencil-alt"></i></a>
                    <a class="btn-circle trans-150 btn-delete" @click="deleteExp(exp.id)"><i class="fas fa-trash-alt"></i></a>
                  </div>
                </div>
              </div>
            </section>
            <!--  -->

            <!-- Portafolio laboral -->
            <section class="cv-section">
              <div class="col-12 box-sec-title">
                <div class="col col-icon">
                  <img src="public/images/pages/account/cv-icon-portfolio.png">
                </div>
                <div class="col col-title">
                  <h5 class="title">Portafolio laboral</h5>
                  <div class="box-btn">
                    <a class="btn btn-cur-1 btn-edit" @click="selectedModalCV = 'cv4-portfolio'">Agregar</a>
                  </div>
                  <hr class="sep" />
                </div>
              </div>

              <div class="col-12 box-portfolio">
                <div class="row">
                  <div class="col-6 col-sm-4 col-md-3 col-xl-2 col-portfolio-file" v-for="(prtf, prFilInx) in $root.user.cv.briefcase" :key="'prFilInx-'+prFilInx">
                    <div class="box-image">
                      <a class="trans-150" :href="prtf.documentUrl" target="_blank">
                        <img src="public/images/pages/account/img-prev-file.png">
                      </a>
                    </div>

                    <div class="box-inf">
                      <h6>{{prtf.titulo}}</h6>
                    </div>

                    <div class="box-buttons">
                      <a download class="btn-circle trans-150 btn-delete" @click="deletePrtf(prtf.id)"><i class="fas fa-trash-alt"></i></a>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <!--  -->

            <!-- Logros destacados -->
            <section class="cv-section">
              <div class="col-12 box-sec-title">
                <div class="col col-icon">
                  <img src="public/images/pages/account/cv-icon-achievements.png">
                </div>
                <div class="col col-title">
                  <h5 class="title">Logros destacados</h5>
                  <div class="box-btn">
                    <a class="btn btn-cur-1 btn-edit" @click="selectedModalCV = 'cv5-achievements'">Agregar</a>
                  </div>
                  <hr class="sep" />
                </div>
              </div>

              <div class="col-12 box-table-info" v-for="(arch, logInx) in $root.user.cv.achievements" :key="'logInx-'+logInx">
                <div class="row">
                  <div class="col col-years">
                    <h6>{{arch.fecha}}</h6>
                  </div>

                  <div class="col col-info">
                    <h5 class="title">{{arch.titulo}}</h5>
                    <p class="descr">{{arch.descripcion}}</p>
                  </div>

                  <div class="col col-buttons">
                    <a class="btn-circle trans-150 btn-edit" @click="editAch(logInx)"><i class="fas fa-pencil-alt"></i></a>
                    <a class="btn-circle trans-150 btn-delete"  @click="deleteAch(arch.id)"><i class="fas fa-trash-alt"></i></a>
                  </div>
                </div>
              </div>

              <!-- <div class="col-12 box-table-info">
                <div class="row">
                  <div class="col-12 py-3 text-center">
                    <h6 class="f-w-600">No tiene ningun elemento agregado aquí</h6>
                  </div>
                </div>
              </div> -->
            </section>
            <!--  -->

            <!-- Idiomas -->
            <section class="cv-section">
              <div class="col-12 box-sec-title">
                <div class="col col-icon">
                  <img src="public/images/pages/account/cv-icon-languages.png">
                </div>
                <div class="col col-title">
                  <h5 class="title">Idiomas</h5>
                  <div class="box-btn">
                    <a class="btn btn-cur-1 btn-edit" @click="selectedModalCV = 'cv6-languages'">Agregar</a>
                  </div>
                  <hr class="sep" />
                </div>
              </div>

              <div class="col-12 box-table-info" v-for="(lang, idmInx) in $root.user.cv.languages" :key="'idmInx-'+idmInx">
                <div class="row">
                  <div class="col col-years">
                    <h6 class="txt-xl">{{lang.procentaje}}%</h6>
                  </div>

                  <div class="col col-info col-lang">
                    <h5 class="title">{{lang.idioma}}</h5>
                  </div>

                  <div class="col col-buttons">
                    <a class="btn-circle trans-150 btn-edit" @click="editLang(idmInx)"><i class="fas fa-pencil-alt"></i></a>
                    <a class="btn-circle trans-150 btn-delete" @click="deleteLang(lang.id)"><i class="fas fa-trash-alt"></i></a>
                  </div>
                </div>
              </div>
            </section>
            <!--  -->

          </div>
        </div>
      </div>
      <sweet-modal ref="modalLoading" hide-close-button blocking>

        <img src="/public/images/shared/loading.gif" width="30%">
        <p style="text-align: center;"><b>Cargando...</b></p>
    </sweet-modal>
    <sweet-modal ref="modalAlert" :icon="modal.icon">
          <p>{{modal.msg}}</p>
           <br><br>
          <a class="btn btn-info" @click="$refs.modalAlert.close()">Aceptar</a>
    </sweet-modal>

    </div>

    <modal-cv-info v-if="selectedModalCV == 'cv1-informacion'"></modal-cv-info>
    <modal-cv-educ v-if="selectedModalCV == 'cv2-education'" :editing="editing" :id="educID"></modal-cv-educ>
    <modal-cv-exp v-if="selectedModalCV == 'cv3-experience'" :editing="editing" :id="expID"></modal-cv-exp>
    <modal-cv-ptf v-if="selectedModalCV == 'cv4-portfolio'" :editing="editing" :id="achID"></modal-cv-ptf>
    <modal-cv-ach v-if="selectedModalCV == 'cv5-achievements'" :editing="editing" :id="achID"></modal-cv-ach>
    <modal-cv-lang v-if="selectedModalCV == 'cv6-languages'" :editing="editing" :id="achID"></modal-cv-lang>

  </div>
</template>

<script>
import modalCvInfo from './modals/modal-cv-1-info.vue';
import modalCvEduc from './modals/modal-cv-2-education.vue';
import modalCvExp from './modals/modal-cv-3-experience.vue';
import modalCvPtf from './modals/modal-cv-4-portfolio.vue';
import modalCvAch from './modals/modal-cv-5-achievements.vue';
import modalCvLang from './modals/modal-cv-6-languages.vue';
export default {
  components: {
    modalCvInfo, modalCvEduc, modalCvExp, modalCvPtf, modalCvAch, modalCvLang
  },

  data(){
    return{
      selectedModalCV: null, // el valor que selecciona el modal a mostrar
      editing: false, // modal para editar o no

      educID: null, // ID Educación
      expID: null, // ID Experiencia Laboral
      ptfID: null, // ID Portafolio laboral
      achID: null, // ID Logros destacados
      langID: null, // ID Idiomas

      formCV: {
        cvdescription: null,
        check: null,
      },
      modal:{
          icon:null,
          msg:null
      },

    }
  },

  methods: {
    // Editar Educación
    editEduc(idx){
      this.selectedModalCV = 'cv2-education';
      this.editing = true;
      this.educID = idx;
    },
    deleteEduc(id){
        var r = confirm("¿Esta seguro de eliminar este registro?");
          if (r == true) {
              this.$refs.modalLoading.open();
              axios.delete(tools.url("/api/admin/deleteCvEducation/"+id))
              .then((response)=>{
                  this.$refs.modalLoading.close();
                  this.modal.icon = 'success';
                  this.modal.msg = 'Registro eliminado correctamente';
                  this.$refs.modalAlert.open();
                  this.$root.auth();
              })
              .catch((error)=>{
                  this.$refs.modalLoading.close();
                  this.modal.icon = 'error';
                  this.modal.msg = 'Ocurrio un error al eliminar';
                  this.$refs.modalAlert.open();
              });
          }
    },

    // Editar Experiencia Laboral
    editExp(idx){
      this.selectedModalCV = 'cv3-experience';
      this.editing = true;
      this.expID = idx;
    },
    deleteExp(id){
        var r = confirm("¿Esta seguro de eliminar este registro?");
          if (r == true) {
              this.$refs.modalLoading.open();
              axios.delete(tools.url("/api/admin/deleteCvExperiencia/"+id))
              .then((response)=>{
                  this.$refs.modalLoading.close();
                  this.modal.icon = 'success';
                  this.modal.msg = 'Registro eliminado correctamente';
                  this.$refs.modalAlert.open();
                  this.$root.auth();
              })
              .catch((error)=>{
                  this.$refs.modalLoading.close();
                  this.modal.icon = 'error';
                  this.modal.msg = 'Ocurrio un error al eliminar';
                  this.$refs.modalAlert.open();
              });
          }
    },

    // Editar Portafolio laboral
    editPtf(idx){
      this.selectedModalCV = 'cv4-portfolio';
      this.editing = true;
      this.ptfID = idx;
    },

    // Editar Logros destacados
    editAch(idx){
      this.selectedModalCV = 'cv5-achievements';
      this.editing = true;
      this.achID = idx;
    },
    deleteAch(id){
        var r = confirm("¿Esta seguro de eliminar este registro?");
          if (r == true) {
              this.$refs.modalLoading.open();
              axios.delete(tools.url("/api/admin/deleteCvLogros/"+id))
              .then((response)=>{
                  this.$refs.modalLoading.close();
                  this.modal.icon = 'success';
                  this.modal.msg = 'Registro eliminado correctamente';
                  this.$refs.modalAlert.open();
                  this.$root.auth();
              })
              .catch((error)=>{
                  this.$refs.modalLoading.close();
                  this.modal.icon = 'error';
                  this.modal.msg = 'Ocurrio un error al eliminar';
                  this.$refs.modalAlert.open();
              });
          }
    },

    // Editar Idiomas
    editLang(idx){
      this.selectedModalCV = 'cv6-languages';
      this.editing = true;
      this.langID = idx;
    },

    deleteLang(id){
        var r = confirm("¿Esta seguro de eliminar este registro?");
          if (r == true) {
              this.$refs.modalLoading.open();
              axios.delete(tools.url("/api/admin/deleteCvIdiomas/"+id))
              .then((response)=>{
                  this.$refs.modalLoading.close();
                  this.modal.icon = 'success';
                  this.modal.msg = 'Registro eliminado correctamente';
                  this.$refs.modalAlert.open();
                  this.$root.auth();
              })
              .catch((error)=>{
                  this.$refs.modalLoading.close();
                  this.modal.icon = 'error';
                  this.modal.msg = 'Ocurrio un error al eliminar';
                  this.$refs.modalAlert.open();
              });
          }
    },
    deletePrtf(id){
        var r = confirm("¿Esta seguro de eliminar este registro?");
          if (r == true) {
              this.$refs.modalLoading.open();
              axios.delete(tools.url("/api/admin/deleteCvPortafolios/"+id))
              .then((response)=>{
                  this.$refs.modalLoading.close();
                  this.modal.icon = 'success';
                  this.modal.msg = 'Registro eliminado correctamente';
                  this.$refs.modalAlert.open();
                  this.$root.auth();
              })
              .catch((error)=>{
                  this.$refs.modalLoading.close();
                  this.modal.icon = 'error';
                  this.modal.msg = 'Ocurrio un error al eliminar';
                  this.$refs.modalAlert.open();
              });
          }
    },
    

  },
}
</script>
